import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'none',
  historyBasename: ['/:lang/marketplace', '/marketplace'],
  htmlTitle: 'HubSpot Marketplace',
  htmlTitleLangKey: 'marketplaceStorefront.htmlTitle',
  includeDefaultViewportMetaTag: true,
  theme: 'trellis-light',
  icons: {
    icon: {
      src: 'favicon.png',
      type: 'image/png'
    }
  },
  head: {
    scripts: [{
      url: 'https://www.hubspot.com/wt-assets/static-files/compliance/index.js',
      async: true,
      dataAttributes: {
        'data-external-hs-domain': 'true',
        'data-gtm-id': 'GTM-NN9PVWW'
      }
    }]
  }
});